import React from 'react'
import { createRoot } from 'react-dom/client'
import GlobalConfig from './GlobalConfig'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import { ReactNotifications } from 'react-notifications-component'
import * as Sentry from '@sentry/react'
import { I18n } from 'galarm-config'

import 'react-notifications-component/dist/theme.css'
import 'react-widgets/styles.css'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV
})

const { store } = configureStore()
GlobalConfig.store = store

const rootContainer = document.getElementById('root')
const root = createRoot(rootContainer)
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>{I18n.t('somethingWentWrong')}</p>}>
      <Provider store={store}>
        <ReactNotifications />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
